export const UPDATE_MEASUREMENT_TYPE = "UPDATE_MEASUREMENT_TYPE";
export const UPDATE_WINCH_TYPE = "UPDATE_WINCH_TYPE";
export const UPDATE_DRUM_WIDTH = "UPDATE_DRUM_WIDTH";
export const UPDATE_DRUM_SURFACE = "UPDATE_DRUM_SURFACE";
export const UPDATE_MOTOR_TYPE = "UPDATE_MOTOR_TYPE";
export const UPDATE_ROTATION_DIRECTION = "UPDATE_ROTATION_DIRECTION";
export const UPDATE_MOTOR_LAYOUT = "UPDATE_MOTOR_LAYOUT";
export const UPDATE_PRESSURE_ROLLER = "UPDATE_PRESSURE_ROLLER";
export const UPDATE_ROPE_END_CONTROL = "UPDATE_ROPE_END_CONTROL";
export const UPDATE_PAINT_FINISH = "UPDATE_PAINT_FINISH";
export const UPDATE_WIRE_ROPE = "UPDATE_WIRE_ROPE";
export const UPDATE_FASTENERS = "UPDATE_FASTENERS";
export const UPDATE_EXTERNAL_BRAKE_RELEASE = "UPDATE_EXTERNAL_BRAKE_RELEASE";
export const UPDATE_THROTTLE_VALVE = "UPDATE_THROTTLE_VALVE";
export const UPDATE_LOAD_MEASURING = "UPDATE_LOAD_MEASURING";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const UPDATE_PREVIEW_PAGE = "UPDATE_PREVIEW_PAGE";
export const UPDATE_PDF_LINK = "UPDATE_PDF_LINK";
export const UPDATE_USER_ID = "UPDATE_USER_ID";
export const UPDATE_PRODUCT_ID = "UPDATE_PRODUCT_ID";
export const UPDATE_ORDER_CODE = "UPDATE_ORDER_CODE";
export const UPDATE_PREVIEW_STATUS = "UPDATE_PREVIEW_STATUS";
export const UPDATE_COUNTRY_LIST = "UPDATE_COUNTRY_LIST";
export const UPDATE_CLEARED_STATUS = "UPDATE_CLEARED_STATUS";
export const UPDATE_VALIDATE_WINCH = "UPDATE_VALIDATE_WINCH";
export const UPDATE_VALIDATE_MOTOR_TYPE = "UPDATE_VALIDATE_MOTOR_TYPE";
export const UPDATE_VALIDATE_MOTOR_LAYOUT = "UPDATE_VALIDATE_MOTOR_LAYOUT";
export const UPDATE_VALIDATE_ROTATION_DIRECTION = "UPDATE_VALIDATE_ROTATION_DIRECTION";
export const UPDATE_VALIDATE_PAINT_FINISH = "UPDATE_VALIDATE_PAINT_FINISH";

export const updateMeasurementType = measurementType => ({
  type: UPDATE_MEASUREMENT_TYPE,
  payload: {
    mType: measurementType
  }
});

export const updateWinchSelection = wType => ({
  type: UPDATE_WINCH_TYPE,
  payload: {
    winchType: wType
  }
});

export const updateDrumWidthSelection = drumWidth => ({
  type: UPDATE_DRUM_WIDTH,
  payload: {
    drumWidth: drumWidth
  }
});

export const updateDrumSurfaceSelection = drumSurface => ({
  type: UPDATE_DRUM_SURFACE,
  payload: {
    drumSurface: drumSurface
  }
});

export const updateMotorTypeSelection = motorType => ({
  type: UPDATE_MOTOR_TYPE,
  payload: {
    motorType: motorType
  }
});

export const updateRotationDirection = rotationDirection => ({
  type: UPDATE_ROTATION_DIRECTION,
  payload: {
    rotationDirection: rotationDirection
  }
});

export const updateMotorLayout = motorLayout => ({
  type: UPDATE_MOTOR_LAYOUT,
  payload: {
    motorLayout: motorLayout
  }
});

export const updatePressureRoller = pressureRoller => ({
  type: UPDATE_PRESSURE_ROLLER,
  payload: {
    pressureRoller: pressureRoller
  }
});

export const updateRopeEndControl = red => ({
  type: UPDATE_ROPE_END_CONTROL,
  payload: {
    ropeEndControl: red
  }
});

export const updatePaintFinish = paintFinish => ({
  type: UPDATE_PAINT_FINISH,
  payload: {
    paintFinish: paintFinish
  }
});

export const updateWireRope = wireRope => ({
  type: UPDATE_WIRE_ROPE,
  payload: {
    wireRope: wireRope
  }
});

export const updateFasteners = fasteners => ({
  type: UPDATE_FASTENERS,
  payload: {
    fasteners: fasteners
  }
});

export const updateExternalBrakeRelease = ebr => ({
  type: UPDATE_EXTERNAL_BRAKE_RELEASE,
  payload: {
    externalBrakeRelease: ebr
  }
});

export const updateThrottleValve = throttleValve => ({
  type: UPDATE_THROTTLE_VALVE,
  payload: {
    throttleValve: throttleValve
  }
});

export const updateLoadMeasuring = loadMeasuring => ({
  type: UPDATE_LOAD_MEASURING,
  payload: {
    loadMeasuring: loadMeasuring
  }
});

export const updateUserDetails = userDetails => ({
  type: UPDATE_USER_DETAILS,
  payload: {
    userDetails: userDetails
  }
});

export const updatePreviewPage = previewHtml => ({
  type: UPDATE_PREVIEW_PAGE,
  payload: {
    previewHtml: previewHtml
  }
});

export const updatePdfLink = pdfLink => ({
  type: UPDATE_PDF_LINK,
  payload: {
    pdfLink: pdfLink
  }
});

export const updateUserId = userId => ({
  type: UPDATE_USER_ID,
  payload: {
    userId: userId
  }
});

export const updateProductId = productId => ({
  type: UPDATE_PRODUCT_ID,
  payload: {
    productId: productId
  }
});

export const updateOrderCode = oCode => ({
  type: UPDATE_ORDER_CODE,
  payload: {
    orderCode: oCode
  }
});

export const updatePreviewStatus = previewStatus => ({
  type: UPDATE_PREVIEW_STATUS,
  payload: {
    previewStatus: previewStatus
  }
});

export const updateCountryList = countryList => ({
  type: UPDATE_COUNTRY_LIST,
  payload: {
    countryList: countryList
  }
})

export const clearStorage = cleared => ({
  type: UPDATE_CLEARED_STATUS,
  payload: {
    cleared: cleared
  }
})

export const validateWinchType = valid => ({
  type: UPDATE_VALIDATE_WINCH,
  payload: {
    valid: valid
  }
})

export const validateMotorType = valid => ({
  type: UPDATE_VALIDATE_MOTOR_TYPE,
  payload: {
    valid: valid
  }
})

export const validateMotorLayout = valid => ({
  type: UPDATE_VALIDATE_MOTOR_LAYOUT,
  payload: {
    valid: valid
  }
})

export const validateRotationDirection = valid => ({
  type: UPDATE_VALIDATE_ROTATION_DIRECTION,
  payload: {
    valid: valid
  }
})

export const validatePaintFinish = valid => ({
  type: UPDATE_VALIDATE_PAINT_FINISH,
  payload: {
    valid: valid
  }
})


// WEBPACK FOOTER //
// ./src/actions/index.js